var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2191_1220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7599 120H25.5737L11.7737 106.262V12.7448L24.5185 0H95.8771L108.498 12.6414V106.262L94.7599 120ZM26.484 117.931H93.9323L106.47 105.517V13.469L95.0289 2.06897H25.3461L13.8426 13.5724V105.517L26.484 117.931Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8082 109.655H33.3737L22.6357 98.4207V21.5793L33.9737 9.80688H86.0288L98.4426 21.4759V98.4207L87.8082 109.655ZM33.8082 108.641H87.3737L97.4702 98.1103V21.9103L85.6151 10.8207H34.4082L23.6495 21.9931V98.0276L33.8082 108.641Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0978 106.241L12.4978 105.517L22.7185 97.9862C23.6495 95.0483 37.2013 51.2069 33.7047 10.6345L24.5806 1.3655L25.284 0.662048L34.6771 10.0965V10.3448C38.3806 52.3448 23.7737 97.9241 23.6288 98.3793V98.5448L13.0978 106.241Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4005 119.297L25.5936 118.676L33.0832 108.89C33.2694 105.704 36.0005 55.0967 22.7384 22.0967L12.3936 13.5518L13.0556 12.7656L23.566 21.6001C37.3453 55.6139 34.0556 108.497 34.0349 109.097V109.262L26.4005 119.297Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.174 106.241L97.553 98.5448V98.4C84.0012 62.5034 85.3047 10.8207 85.3047 10.3448V10.1379L95.0909 0.641357L95.7943 1.38619L86.2564 10.531C86.2564 14.1517 85.4081 63.3724 98.3392 97.9241L107.794 105.517L107.174 106.241Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9315 119.276L87.0833 109.138C81.9315 71.8964 97.4281 22.0343 97.4281 21.5378V21.4137L107.152 12.6826L107.835 13.4274L98.4212 21.9723C97.5315 24.8481 83.1315 72.8688 88.0764 108.869L94.7591 118.696L93.9315 119.276Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7867 109.531L33.3936 108.6C33.7867 108.434 72.8073 92.4414 98.0694 97.7172L97.8625 98.731C72.9108 93.5172 34.1591 109.366 33.7867 109.531Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6002 109.531C87.2278 109.366 48.4761 93.5172 23.4623 98.731L23.2554 97.7172C48.5174 92.4621 87.5381 108.434 87.9312 108.6L87.6002 109.531Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0987 23.1516C30.2933 23.187 26.4942 22.8334 22.7607 22.0965L22.9676 21.1033C47.9194 26.2964 85.2435 10.4482 85.6159 10.3447L86.0297 11.2758C85.6987 11.3585 57.9332 23.1516 34.0987 23.1516Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6917 23.1516C62.6917 23.1516 34.3262 11.3585 33.9951 11.2137L34.3882 10.3447C34.7813 10.5102 72.8917 26.3585 97.8641 21.1654L98.071 22.1585C94.3216 22.8759 90.5087 23.2087 86.6917 23.1516Z",
    fill: "#81D8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2191_1220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.7241,
    height: 120,
    fill: "white",
    transform: "translate(11.7737)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiant);
export default __webpack_public_path__ + "static/media/Radiant.5f49aaeec4943a91f342421f5ff3be32.svg";
export { ForwardRef as ReactComponent };